module.exports = __webpack_public_path__ + "media/images/big-star-fba79834cc20cdea05b23d523e78230c.png";